import { Power } from 'lucide-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axiosInstance';
import homewindowLogo from '../image/homewindow_logo.png';
import { PermissionManager } from '../utils/PermissionManager';
import './css/adminPage.css';
import UnitPriceManagement from './UnitPriceManagement';

const CRM_WEB_URL = process.env.REACT_APP_CRM_WEB_URL || 'https://crm.cahwindow.co.kr';

function AdminDashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!PermissionManager.canAccessAdminPage()) {
      alert('관리자만 접근 가능합니다.');
      navigate('/');
    }
  }, [navigate]);

  const handleLogout = async () => {
    try {
      await api.post('/api/logout');
      localStorage.removeItem('accessToken');
      alert('로그아웃 되었습니다.');
      navigate('/');
    } catch (error) {
      console.error('로그아웃 실패:', error);
      alert('로그아웃에 실패했습니다.');
    }
  };

  return (
    <div className="admin-container">
      {/* 헤더 */}
      <div className="admin-header">
        <div className="admin-header-left">
          <img src={homewindowLogo} alt="Logo" className="admin-image" />
          <span className="admin-title">관리자 페이지</span>
        </div>
        <button className="logout-btn" onClick={handleLogout}>
          <Power size={16} />
          로그아웃
        </button>
      </div>

      <UnitPriceManagement />

      <div style={{
        margin: '20px',
        padding: '15px',
        backgroundColor: '#f8f9fa',
        border: '1px solid #dee2e6',
        borderRadius: '4px'
      }}>
        <h4 style={{ marginTop: 0 }}>👤 사용자 관리</h4>
        <p>
          사용자 계정 관리는 <strong>CRM</strong>에서 진행하십시오.
        </p>
        <p style={{ marginBottom: 0 }}>
          <a
            href={`${CRM_WEB_URL}/admin/users`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#007bff', textDecoration: 'none' }}
          >
            → 사용자 관리 페이지로 이동
          </a>
        </p>
      </div>
    </div>
  );
}

export default AdminDashboard;
